export default __webpack_public_path__ + "static/media/nft4.b102a83f.jpeg";